module.exports = __webpack_public_path__ + "img/warn_bg.42ac077e.png";